'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtSelectFacebookCategory', [
	'$http',
	'$stateParams',
	'auth',
	'$window',
	function ($http, $stateParams, auth, $window) {
		return {
			restrict: 'A',
			replace: true,
			scope: {},
			link: function (scope) {
				scope.site = $stateParams.site;
				let facebookData = auth.user.selectedSite.places.facebook;
				scope.hasPageToken = facebookData.hasPageToken;
				scope.hasCategory = facebookData.subcategories && facebookData.subcategories.length > 0;

				let selectCategory = function () {
					let tempCat = [];
					if (scope.hasCategory && scope.categories) {
						tempCat[0] = scope.categories.filter(function (cat) {
							return (
								facebookData.subcategories[0] && facebookData.subcategories[0].name === cat.name
							);
						});
						tempCat[1] = scope.categories.filter(function (cat) {
							return (
								facebookData.subcategories[1] && facebookData.subcategories[1].name === cat.name
							);
						});
						tempCat[2] = scope.categories.filter(function (cat) {
							return (
								facebookData.subcategories[2] && facebookData.subcategories[2].name === cat.name
							);
						});
						scope.selectedSubCategory1 = tempCat[0][0];
						scope.selectedSubCategory2 = tempCat[1][0];
						scope.selectedSubCategory3 = tempCat[2][0];
					} else if (facebookData.data && facebookData.data.subCategory[0]) {
						tempCat[0] = scope.categories.filter(function (cat) {
							return facebookData.data.subCategory[0] === cat.name;
						});
						tempCat[1] = scope.categories.filter(function (cat) {
							return facebookData.data.subCategory[1] === cat.name;
						});
						tempCat[2] = scope.categories.filter(function (cat) {
							return facebookData.data.subCategory[2] === cat.name;
						});
						scope.selectedSubCategory1 = tempCat[0][0];
						scope.selectedSubCategory2 = tempCat[1][0];
						scope.selectedSubCategory3 = tempCat[2][0];
					}
				};

				$http.get('api/' + scope.site + '/facebook/categories').then(function (res) {
					scope.categories = res.data.data;
					selectCategory();
				});

				scope.setSelectedCategory = function () {
					if (scope.selectedSubCategory1) {
						let categories = [
							scope.selectedSubCategory1,
							scope.selectedSubCategory2,
							scope.selectedSubCategory3
						];
						$http
							.post('api/' + scope.site + '/facebook/category/primary', { categories: categories })
							.then(function (res) {
								if (res.data.success) {
									$window.location.reload();
								}
							});
					} else {
						window.alert('ERROR no selected category..');
					}
				};
			},
			templateUrl: 'components/claim/facebook/pmt-select-facebook-category.html'
		};
	}
]);
